import axios from "../../axios";
import { dateStart, dateEnd } from "../../utils/util";

const getScheduledTickets = async () => {
  let today = new Date();
  let startDate = dateStart(today);
  let endDate = dateEnd(today);

  // console.log(startDate, endDate);
  try {
    const { data } = await axios.get(`/service_tickets?status[$in]=scheduled,checked_in,prepping,in_progress&scheduled_check_in_at[$gte]=${startDate}&scheduled_check_in_at[$lte]=${endDate}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
}

const getTicketById = async (id) => {
  try {
    const { data } = await axios.get(`/repair_tickets/${id}`);
    return data;
  } catch (e) {
    return null;
  }
}


const searchTickets = async (search, st = "in_house") => {
  let searchTerm = search ? `&term[search]=${search}` : '';
  st = st === "in_house" ? true : false
  try {
    const { data } = await axios.get(`/repair_tickets/dashboard?status[$in]=scheduled,in_progress,accepted,transit&rt.in_house=${st}${searchTerm}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const getStations = async () => {
  try {
    const { data } = await axios.get(`/services/stations?station_type[$eq]=repair`);
    return data;
  } catch (e) {
    return null;
  }
}

const updateStage = async ({repair_ticket_id, step = "start"}) => {
  try {
    const { data } = await axios.put(`/repair_tickets/stages/${repair_ticket_id}?step=${step}`, {});
    return data;
  } catch (e) {
    return null;
  }
}

const markStageComplete = async ({repair_task_id}) => {
  try {
    const { data } = await axios.put(`/repair_tickets/mark-complete/${repair_task_id}`, {});
    return data;
  } catch (e) {
    return null;
  }
}

const editTask = async ({repair_task_id, dataPacket}) => {

  console.log(dataPacket, "dataPacket", repair_task_id, "repair_task_id");
  try {
    const { data } = await axios.put(`/repair_tickets/tasks/${repair_task_id}`, dataPacket);
    return data;
  } catch (e) {
    return null;
  }
}

const deleteTask = async (repair_task_id) => {
  try {
    const { data } = await axios.delete(`/repair_tickets/repair_tasks/${repair_task_id}`);
    return data;
  } catch (e) {
    return null;
  }
}

const editRepair = async ({repair_ticket_id, dataPacket}) => {
  console.log(dataPacket, "dataPacket");
  try {
    const { data } = await axios.put(`/repair_tickets/${repair_ticket_id}`, {...dataPacket});
    return data;
  } catch (e) {
    return null;
  }
}

const modifyStages = ({repair_ticket_id, prep_stages}) => {
  try {
    const { data } = axios.put(`/repair_tickets/modify-stages/${repair_ticket_id}`, {prep_stages});
    return data;
  } catch (e) {
    return null;
  }
}

const searchOpenTickets = async (customer_id, wig_id, repair_ticket_id) => {
  let searchTerm = wig_id ? `&wig_id[$eq]=${wig_id}` : '';
  let rti = repair_ticket_id ? `&repair_ticket_id[$ne]=${repair_ticket_id}` : '';
  try {
    const { data } = await axios.get(`/repair_tickets?status[$in]=scheduled&customer_id[$eq]=${customer_id}${rti}${searchTerm}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const saveStationView = async (list, view) => {
  try {
    let dataPacket = {
      resource: "repairs",
      resource_tab: view,
      settings_level: "user",
      data: list
    }

    let { data } = await axios.post(`/settings`, dataPacket);
    return data;
  } catch (e) {
    return null;
  }
}

const getStationView = async (view) => {
  try {
    let { data } = await axios.get(`/settings/repairs/${view}`);
    return data;
  } catch (e) {
    return null;
  }
}

const getTicketsByTasks = async(tasks) => {
  try {
    const { data } = await axios.get(`/repair_tickets?rt.repair_task_id[$in]=${tasks}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
}

const getAllTasks = async(tasks) => {
  try {
    const { data } = await axios.get(`/repair_tickets/tasks?repair_task_id[$in]=${tasks}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
}




export { searchTickets, getScheduledTickets, getTicketById, getStations, updateStage, modifyStages, searchOpenTickets, saveStationView, getStationView, editRepair, getTicketsByTasks, getAllTasks, editTask, deleteTask, markStageComplete };
